var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"2","height":"53","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill":"none","stroke":"currentColor","stroke-width":"2","d":"M1.5 0v53"}})])}
var staticRenderFns = []

export { render, staticRenderFns }